
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Comprendre le Concept de Persona en Marketing: Explication et Rôle",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez tout ce que vous devez savoir sur le persona-en-marketing. Une définition claire et précise pour mieux comprendre cette stratégie de marketing incontournable.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comprendre le Concept de Persona en Marketing: Explication et Rôle",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez tout ce que vous devez savoir sur le persona-en-marketing. Une définition claire et précise pour mieux comprendre cette stratégie de marketing incontournable.",
        },
      ],
    };
  },
};
